<template>
  <div style="text-align:center">
    <div v-if="darkMode">
      <h1>Welcome to the Dark Side</h1>
      <div>
        I'm scared, take me back
        <a href="#" @click.prevent="light">to the light.</a>
      </div>
      <img src="@/assets/img/varder.png" />
    </div>
    <div v-else>
      <h1>Welcome to the light side</h1>
      <div>
        Take me back
        <a href="#" @click.prevent="dark">to the dark side.</a>
      </div>
      <img src="@/assets/img/elsa.jpeg" />
    </div>
  </div>
</template>

<script>
export default {
  created() {
    var current = this.$localStorageService.getItem("data-theme");
    if (current && current == "dark") {
      this.darkMode = true;
    } else {
      this.darkMode = false;
    }
  },
  data() {
    return {
      darkMode: false,
    };
  },

  methods: {
    dark() {
      this.$localStorageService.setItem("data-theme", "dark");
      document.documentElement.setAttribute("data-theme", "dark");
      this.darkMode = true;
    },
    light() {
      localStorage.removeItem("data-theme");
      document.documentElement.removeAttribute("data-theme");
      this.darkMode = false;
    },
    darkModeToggle() {
      var current = this.$localStorageService.getItem("data-theme");
      if (!current || (current && current == "dark")) {
        this.dark = true;
        this.$localStorageService.setItem("data-theme", "light");
      } else {
        this.dark = false;
        this.$localStorageService.setItem("data-theme", "dark");
      }
      document.documentElement.setAttribute(
        "data-theme",
        this.$localStorageService.getItem("data-theme")
      );
    },
  },
};
</script>

<style></style>
